(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dv-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dv-delivery-estimate'))customElements.define('dv-delivery-estimate',class extends HTMLElement{
  connectedCallback(){const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());const value=type=>Number(parts.find(part=>part.type===type).value);const dispatch=new Date(Date.UTC(value('year'),value('month')-1,value('day'),12));const weekday=date=>date.getUTCDay()!==0&&date.getUTCDay()!==6;do{dispatch.setUTCDate(dispatch.getUTCDate()+1)}while(!weekday(dispatch));const standard=new Date(dispatch);standard.setUTCDate(standard.getUTCDate()+4);while(!weekday(standard))standard.setUTCDate(standard.getUTCDate()+1);const express=new Date(dispatch);for(let count=0;count<2;){express.setUTCDate(express.getUTCDate()+1);if(weekday(express))count++}for(const [selector,date] of [['[data-standard]',standard],['[data-express]',express]]){const node=this.querySelector(selector);node.dateTime=date.toISOString().slice(0,10);node.textContent=new Intl.DateTimeFormat(this.dataset.language||'es',{timeZone:'UTC',day:'2-digit',month:'2-digit',year:'numeric'}).format(date)}}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dv-menu-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dv-menu-preview'))customElements.define('dv-menu-preview',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;const photo=this.querySelector('.dv-menu__preview img'),caption=this.querySelector('.dv-menu__preview span'),target=this.querySelector('.dv-menu__preview');if(!photo)return;const original={src:photo.src,srcset:photo.srcset,alt:photo.alt,label:caption.textContent,url:target.href};let token=0;const reset=()=>{token++;photo.src=original.src;photo.srcset=original.srcset;photo.alt=original.alt;caption.textContent=original.label;target.href=original.url};const update=e=>{const a=e.target.closest('.dv-menu__links a');if(!a||!a.dataset.preview){reset();return}const current=++token;const img=new Image();img.onload=()=>{if(current!==token)return;photo.removeAttribute('srcset');photo.src=img.src;photo.alt=a.dataset.label;caption.textContent=a.dataset.label;target.href=a.href};img.src=a.dataset.preview};this.addEventListener('pointerover',update);this.addEventListener('focusin',update);this.addEventListener('pointerleave',reset);this.closest('details')?.addEventListener('toggle',reset)}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dv-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dv-product-details')) {
  customElements.define('dv-product-details', class extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-dv-description]');
      if (!source || this.dataset.ready) return;
      this.dataset.ready = 'true';
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f\u200b-\u200d\ufeff]/g, '').replace(/\s+/g, ' ').trim();
      const marker = Array.from(source.querySelectorAll('p,h2,h3,h4,h5,h6,div')).find(node => /^(?:material(?:es)?\s+y\s+cuidados?|composicion(?:\s+y\s+cuidados)?|material\s*\/\s*cuidados)\s*[:.]?$/i.test(normalize(node.textContent)));
      if (!marker) return;
      const range = document.createRange();
      range.setStartAfter(marker);
      range.setEnd(source, source.childNodes.length);
      const fragment = range.cloneContents();
      if (!normalize(fragment.textContent)) return;
      const target = this.querySelector('[data-dv-care-content]');
      target.append(range.extractContents());
      marker.remove();
      this.querySelector('[data-dv-care]').hidden = false;
      if (!normalize(source.textContent) && !source.querySelector('img,video,table')) this.querySelector('[data-dv-details]').hidden = true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dv-purchase-clarity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dv-size-gate')) {
  const confirmed = new Set();
  customElements.define('dv-size-gate', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const formId = this.dataset.form;
      const productId = this.dataset.product;
      const position = this.dataset.position;
      const scope = this.closest('.product-info');
      const update = () => {
        if (confirmed.has(productId)) return;
        const form = document.getElementById(formId);
        const button = form?.querySelector('button[type="submit"]');
        if (button && !button.disabled) { button.dataset.dvOriginalLabel = button.textContent; button.textContent = this.dataset.label; button.disabled = true; }
        const prompt = this.querySelector('p');
        if (prompt) { prompt.hidden = false; scope?.querySelector('.product-info__variant-picker')?.prepend(prompt); }
      };
      document.addEventListener('click', event => {
        const label = event.target.closest('label[for]');
        const input = label ? document.getElementById(label.htmlFor) : event.target;
        if (input?.getAttribute('form') === formId && input.dataset.optionPosition === position && !label?.classList.contains('is-disabled')) {
          confirmed.add(productId);
          const button = document.getElementById(formId)?.querySelector('button[type="submit"]');
          if (button?.dataset.dvOriginalLabel) { button.textContent = button.dataset.dvOriginalLabel; button.disabled = false; }
        }
      }, {capture:true, signal});
      document.addEventListener('change', event => {
        const input = event.target;
        if (input.getAttribute('form') === formId && input.dataset.optionPosition === position) confirmed.add(productId);
      }, {capture:true, signal});
      document.addEventListener('submit', event => {
        if (event.target.id !== formId || confirmed.has(productId)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const prompt = this.querySelector('p');
        prompt.hidden = false;
        const picker = scope?.querySelector('.product-info__variant-picker');
        picker?.scrollIntoView({block:'center',behavior:'smooth'});
        prompt.focus({preventScroll:true});
      }, {capture:true, signal});
      requestAnimationFrame(update);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
